import React from "react";
import { MandatoryBadge } from "@hyro-components/MandatoryBadge";
import Tooltip from "@hyro-components/Tooltip";
import QuestionIcon from "src/icons/insights/QuestionIcon";
import { READ_ONLY_TABLE_COLUMN_TOOLTIP } from "src/components/collections/consts";
import { Box } from "@mui/material";
import HyroTruncateTypography from "@hyro-components/hyro-truncate-typography/HyroTruncateTypography";

const SORT_ICON_SIZE = 48;

const ColumnHeader = ({
  params,
  column,
  colIndex,
  testId,
  columnStyle
}) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      fontWeight: "bold",
      gap: theme => theme.spacing(1),
      ...columnStyle
    }}
    data-testid={`${testId}-header-${colIndex}`}
  >
    <HyroTruncateTypography
      maxWidth={`${params.colDef?.minWidth - SORT_ICON_SIZE}px`}
      variant="tableHeader1"
    >
      {params.colDef?.headerName}
    </HyroTruncateTypography>
    {column?.showError ? (
      <MandatoryBadge />
    ) : column?.showTooltip ? (
      <Tooltip
        variant="light"
        title={column?.tooltipText ?? READ_ONLY_TABLE_COLUMN_TOOLTIP}
        tooltipStyle={{ width: column?.tooltipWidth ?? 200 }}
      >
        <div style={{ width: 16, height: 16 }}>
          <QuestionIcon />
        </div>
      </Tooltip>
    ) : null}
  </Box>
);

export default ColumnHeader;
